export default __webpack_public_path__ + "19623cc0d958ea245f4db814c4ab1642.png";